export const pl = {
    translation: {
        b: {
            cancel: 'Anuluj',
            confirm: 'Potwierdź',
            send: 'Wyślij',
            done: 'Gotowe',
            close: 'Zamknij',
            clear: 'Wyczyść',
            copy_link: 'Kopiuj link',
            export: 'Eksportuj',
            delete: 'Usuń',
            delete_confirm: 'Potwierdź usunięcie',
            duplicate: 'Duplikuj',
            share: 'Udostępnij',
            sign_in: 'Zaloguj się',
            sign_up: 'Zarejestruj się',
            email_address: 'Adres e-mail',
            yes: 'Tak',
            no: 'Nie'
        },
        m_languages: {
            title: 'Języki',
            subtitle: 'Wybierz język'
        },
        m_feedback: {
            feature: {
                name: 'Prośba o funkcję',
                desc: 'Brakuje funkcji, której potrzebujesz? Daj nam znać — Twoje pomysły są ważne'
            },
            feedback: {
                name: 'Opinie',
                desc: 'Twoja opinia jest dla nas bardzo cenna — zostaw krótką wiadomość'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Dziękujemy za sugestię!',
                desc: 'Doceniamy, że poświęciłeś czas na podzielenie się opinią — pomaga nam to ulepszać produkt.'
            },
            feedback: {
                name: 'Dziękujemy za opinię!',
                desc: 'Doceniamy, że poświęciłeś czas na podzielenie się opinią — pomaga nam to ulepszać produkt.'
            }
        },
        m_diagram_details: {
            name_place: 'Wpisz nazwę projektu',
            desc_place: 'Wpisz opis projektu'
        },
        m_quick_share: {
            title: 'Szybkie udostępnianie',
            subtitle: '(Przez link)'
        },
        m_export_img: {
            title: 'Eksportuj obraz'
        },
        m_export_code: {
            title: 'Eksportuj kod {{db_engine}}',
            download_file: 'Pobierz plik',
            copy_code: 'Kopiuj kod'
        },
        m_sign_in_remind: {
            title: 'Dziękujemy za wypróbowanie DB Design',
            subtitle: 'Zaloguj się lub zarejestruj, aby zwiększyć maksymalną liczbę tabel, zapisywać diagramy i odblokować więcej funkcji.'
        },
        m_sign_in_restrict: {
            title: 'Zaloguj się, aby zrobić więcej w aplikacji',
            subtitle: 'Zaloguj się lub zarejestruj, aby zwiększyć limity tabel, zapisywać diagramy i odblokować więcej funkcji.'
        },
        m_new_diagram: {
            title: 'Nowy diagram',
            subtitle: 'Wybierz silnik bazy danych',
            open_diagram: 'Otwórz diagram'
        },
        m_keyboard_shortcuts: {
            title: 'Skróty klawiaturowe',
            ctrl_left: {
                title1: 'Sterowanie',
                title2: '(Lewo)',
                items: {
                    mouse_sel: 'Zaznaczanie myszą / Tryb ręki',
                    table: 'Tabela',
                    line: 'Linia',
                    area: 'Obszar',
                    note: 'Notatka',
                    comment: 'Komentarz',
                    pen: 'Ołówek',
                    undo: 'Cofnij',
                    redo: 'Ponów'
                }
            },
            ctrl_top_left: {
                title1: 'Sterowanie',
                title2: '(Lewy górny)',
                items: {
                    export_img: 'Eksportuj obraz',
                    search: 'Szukaj',
                    editor_panel: 'Panel edytora'
                }
            },
            ctrl_bottom_right: {
                title1: 'Sterowanie',
                title2: '(Prawy dolny)',
                items: {
                    minimap: 'Minimapa',
                    zoom_in: 'Powiększ',
                    zoom_out: 'Pomniejsz',
                    zoom_100: 'Zoom 100%'
                }
            },
            ctx_tab: {
                title1: 'Menu kontekstowe',
                title2: '(Tabela)',
                items: {
                    dupl_tab: 'Duplikuj tabelę',
                    del_tab: 'Usuń tabelę'
                }
            },
            ctx_del_tab: {
                title1: 'Menu kontekstowe',
                title2: '(Usuń tabelę)',
                items: {
                    yes: 'Tak',
                    no: 'Nie'
                }
            },
            ctx_tab_col: {
                title1: 'Menu kontekstowe',
                title2: '(Kolumna tabeli)',
                items: {
                    add_col_below: 'Dodaj kolumnę poniżej',
                    focus_col_above: 'Ustaw fokus na kolumnie powyżej',
                    focus_col_below: 'Ustaw fokus na kolumnie poniżej',
                    move_col_up: 'Przenieś kolumnę w górę',
                    move_col_down: 'Przenieś kolumnę w dół',
                    dupl_col: 'Duplikuj kolumnę',
                    del_col: 'Usuń kolumnę'
                }
            },
            ctx_line: {
                title1: 'Menu kontekstowe',
                title2: '(Linia)',
                items: {
                    del_line: 'Usuń linię'
                }
            },
            ctx_area: {
                title1: 'Menu kontekstowe',
                title2: '(Obszar)',
                items: {
                    dupl_area: 'Duplikuj obszar',
                    del_area: 'Usuń obszar'
                }
            },
            ctx_multi: {
                title1: 'Menu kontekstowe',
                title2: '(Wielokrotny wybór)',
                items: {
                    select_all: 'Zaznacz wszystkie elementy',
                    create_area_for_select_els: 'Utwórz obszar dla zaznaczonych elementów',
                    dupl_select_els: 'Duplikuj zaznaczone elementy',
                    del_select_els: 'Usuń zaznaczone elementy'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Zaznaczanie myszą',
                table: 'Tabela',
                line: 'Linia',
                area: 'Obszar',
                note: 'Notatka (wkrótce)',
                comment: 'Komentarz (wkrótce)',
                pen: 'Ołówek',
                undo: 'Cofnij',
                redo: 'Ponów'
            },
            ctrl_top_left: {
                logo: 'Uwaga: sandbox (środowisko testowe)',
                name: 'Informacje o diagramie',
                editor: 'Edytor (wkrótce)',
                search: 'Wyszukiwanie (wkrótce)',
                export: 'Opcje eksportu',
                view_mode: 'Tryb widoku',
                zoom_to_fit: 'Dopasuj do ekranu'
            },
            ctrl_top_right: {
                feature_req: 'Prośba o funkcję',
                sign_in: 'Zaloguj się',
                quick_share: 'Szybkie udostępnianie'
            },
            ctrl_bottom_right: {
                full_screen: 'Pełny ekran',
                minimap: 'Minimapa',
                zoom_out: 'Pomniejsz',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Powiększ',
                info: 'Informacje i zasoby'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Domyślny',
                        blue: 'Niebieski',
                        green: 'Zielony',
                        red: 'Czerwony',
                        purple: 'Purpurowy',
                        violet: 'Fioletowy'
                    },
                    borders: {
                        none: 'Brak',
                        solid: 'Ciągła',
                        dashed: 'Kreskowana',
                        dotted: 'Kropkowana'
                    },
                    color: 'Kolor',
                    border: 'Obramowanie',
                    description: 'Opis',
                    description_table_place: 'Opis tabeli',
                    description_column_place: 'Opis kolumny',
                    description_line_place: 'Opis linii',
                    description_note_place: 'Opis notatki',
                    description_area_place: 'Opis obszaru',
                    description_pen_place: 'Opis ołówka',
                    hide_menu: 'Ukryj menu',
                    show_menu: 'Pokaż menu'
                },
                tab_col: {
                    add_col_below: 'Dodaj kolumnę poniżej',
                    add_col_above: 'Dodaj kolumnę powyżej',
                    key: 'Key',
                    keys: {
                        none: 'Brak',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Brak',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Przenieś kolumnę w dół',
                    move_col_up: 'Przenieś kolumnę w górę',
                    more_functions: 'Więcej funkcji'
                },
                line: {
                    change_connects: 'Zmień łączniki',
                    connects: {
                        empty: 'Puste',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: 'Filtruj elementy'
                },
                multi: {
                    filter: 'Filtruj zaznaczenie',
                    create_area: 'Utwórz obszar'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Pełny',
            keys_only: 'Tylko klucze',
            names_only: 'Tylko nazwy'
        },
        dropdown_ctrl_export: {
            export_img: 'Eksportuj obraz',
            export_code: 'Eksportuj kod SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Zaloguj się',
            new_project: 'Nowy projekt',
            keyboard_shortcuts: 'Skróty klawiaturowe',
            languages: 'Języki'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Opinie',
            keyboard_shortcuts: 'Skróty klawiaturowe',
            languages: 'Języki',
            homepage: 'Strona główna'
        },
        n: {
            default: 'Ładowanie…',
            file_ready_to_download: 'Plik jest gotowy do pobrania',
            code_copied: 'Kod został skopiowany',
            link_copied: 'Link został skopiowany',
            please_enter_message: 'Wpisz wiadomość',
            invalid_email: 'Adres e-mail jest nieprawidłowy',
            something_wrong_contact: 'Coś poszło nie tak. Odśwież stronę lub skontaktuj się z nami.',
            something_wrong: 'Coś poszło nie tak. Odśwież stronę.',
            sending: 'Wysyłanie…',
            request_sent: 'Żądanie zostało wysłane. Dziękujemy!'
        }
    }
};

export const plMeta = {
    lang_origin: 'Polski',
    lang_eng: 'Polish',
    lang_code: 'pl',
};
